import Root from './_Root'
import colorsys from 'colorsys'
import { format } from 'date-fns'

export default class Movie extends Root
    id: ''
    title: ''
    year: ''
    year_to: ''
    type: ''
    runtime: ''
    imdb_url: ''
    imdb_score: ''
    metacricic_score: ''
    imdb_votes: ''
    imdb_topreviews_score: ''
    hidden: ''
    countries: ''
    genres: ''
    languages: ''
    review_id: ''
    written_review: '' # 0 or 1, if there is some text in the review
    own_score: ''
    collection_time: ''
    review_time: ''
    br1080p: '' # 1080p release time
    
    # fields for episodes
    episode_ids: ''
    seasons: ''
    episodes: ''
    air_dates: ''
    episode_reviews: ''

    episode_num_total: 0
    episode_num_reviewed: 0
    bg_style: ''

    summary: ''

    constructor: (original) ->
        super original
        @persons = []
        Root.Copy(original, @)
        # @genres.sort()

        @metacritic_score = '' if not @metacritic_score
        @own_score = '' if @own_score == 0
        @year_to = '' if @year_to == 0
        @runtime_nice = @formatRuntime()

        @determineClass()
        @determineColors()

        @review_time_formatted = if @review_time then format(@review_time, '\'YY-MM-DD') else ''
        @release_time_formatted = if @br1080p then format(@br1080p, '\'YY-MM-DD') else ''
        @collection_time_formatted = if @collection_time then format(@collection_time, '\'YY-MM-DD') else ''
        
        if @type == 'Serie'
            @episode_num_total = @episodes.length
            @episode_num_reviewed = (e for e in @episode_reviews when e).length
            @determineBackgroundStyle()

    getColor: (score) ->
        return "white" if not score
        color = colorsys.hsv_to_rgb
            h: (score + 10) / 100 * 240 - 120
            s: 50
            v: 95
        return "rgb(#{color.r}, #{color.g}, #{color.b})"

    determineClass: ->
        @class = 'ro' if @own_score and @collection_time # reviewed and owned
        @class = 'rno' if @own_score and not @collection_time # reviewed but not owned
        @class = 'nro' if not @own_score and @collection_time # not reviewed but owned
        @class = 'nrnor' if not @own_score and not @collection_time and @br1080p # not reviewed not owned released
        @class = 'nrnonr' if not @own_score and not @collection_time and not @br1080p # not reviewed not owned not released

    determineColors: ->
        @imdb_color = @getColor(@imdb_score)
        @metacritic_color = @getColor(@metacritic_score)
        @own_color = @getColor(@own_score * 10)

    determineBackgroundStyle: ->
        if @episode_num_total > 0 and @episode_num_reviewed > 0
            pct = @episode_num_reviewed / @episode_num_total * 100
            @bg_style = "background: linear-gradient(90deg, #88e5a5 #{pct}%, #ffc5c5 0);"
        else
            @bg_style = ''

    formatRuntime: ->
        hour = Math.floor(@runtime / 60)
        minute = @runtime % 60
        str = ''
        if hour > 0
            str = hour + ':'
            minute = '0' + minute if minute < 10
        str += minute
        if hour == 0
            str += "'"
        return str
